(() => {
  'use strict';
  let pending = false;
  const properties = value => Object.fromEntries((Array.isArray(value) ? value : Object.entries(value || {})).sort(([a], [b]) => a.localeCompare(b)));
  const comparable = value => Object.fromEntries(Object.entries(properties(value)).map(([key, entry]) => [key, key === '_tpo_add_on_keys' || key === '_tpo_add_on_variant_ids' ? JSON.stringify(decodeKeys(entry)) : entry]));
  const sameProperties = (a, b) => JSON.stringify(comparable(a)) === JSON.stringify(comparable(b));
  const matches = (item, identity) => item.variant_id === identity.variantId && sameProperties(item.properties, identity.properties) && (item.selling_plan_allocation?.selling_plan?.id || null) === identity.sellingPlan;
  function decodeKeys(value) {
    if (!value) return [];
    const decoded = String(value).replace(/&quot;/g, '"').replace(/&#34;/g, '"').replace(/&amp;/g, '&');
    try { const keys = JSON.parse(decoded); return Array.isArray(keys) ? keys : []; } catch (_) { return []; }
  }
  function mergedUpdates(cart, identity, quantity) {
    const lines = cart.items.filter(item => matches(item, identity));
    if (!lines.length) throw new Error('Cart line unavailable');
    const updates = {};
    lines.forEach((item, index) => { updates[item.key] = index ? 0 : quantity; });
    const originalQuantity = lines.reduce((sum, item) => sum + item.quantity, 0);
    const addOnKeys = decodeKeys(identity.properties._tpo_add_on_keys);
    const addOns = cart.items.filter(item => addOnKeys.includes(item.properties?._tpo_add_on_key));
    const groups = new Map();
    for (const item of addOns) {
      const key = JSON.stringify([item.variant_id, properties(item.properties)]);
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(item);
    }
    for (const group of groups.values()) {
      if (quantity === 0) { group.forEach(item => { updates[item.key] = 0; }); continue; }
      const multiplier = group.reduce((sum, item) => sum + item.quantity, 0) / originalQuantity;
      if (!Number.isInteger(multiplier)) throw new Error('Option quantity unavailable');
      group.forEach((item, index) => { updates[item.key] = index ? 0 : quantity * multiplier; });
    }
    return updates;
  }
  window.LMDMergedCart = {
    matches,
    mergedUpdates,
    async update(identity, quantity, sections) {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      return fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: mergedUpdates(cart, identity, quantity), sections, sections_url: location.pathname })
      });
    }
  };
  const numberFormat = new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' });
  function groupLines() {
    for (const surface of document.querySelectorAll('#CartDrawer,#main-cart-items')) {
      const groups = new Map();
      const all = [...surface.querySelectorAll('.cart-item[data-line-key]')];
      const values = new Map();
      for (const row of all) {
        try { values.set(row, properties(JSON.parse(row.dataset.lineProperties || '{}'))); } catch (_) {}
      }
      for (const row of all) {
        const props = values.get(row);
        if (props?._tpo_add_on_key) {
          const hasParent = all.some(parent => decodeKeys(values.get(parent)?._tpo_add_on_keys).includes(props._tpo_add_on_key));
          row.toggleAttribute('data-lmd-orphan-option', !hasParent);
        }

        if (!props || props._tpo_add_on_key || row.style.display === 'none') continue;
        const key = JSON.stringify([row.dataset.lineVariant, comparable(props), row.dataset.linePlan]);
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(row);
      }
      for (const rows of groups.values()) {
        const primary = rows[0];
        const addOnKeys = decodeKeys(values.get(primary)._tpo_add_on_keys);
        const addOns = all.filter(row => addOnKeys.includes(values.get(row)?._tpo_add_on_key));
        if (rows.length < 2 && !addOnKeys.length) continue;
        const quantity = rows.reduce((sum, row) => sum + Number(row.dataset.lineQuantity || 0), 0);
        primary.dataset.lmdMerged = 'true';
        const input = primary.querySelector('.quantity__input');
        if (input && input.dataset.lmdMergedQuantity !== String(quantity)) {
          input.value = quantity;
          input.dataset.lmdMergedQuantity = String(quantity);
        }
        for (const row of rows.slice(1)) row.dataset.lmdMergedAway = 'true';
        const total = [...rows, ...addOns].reduce((sum, row) => sum + Number(row.dataset.linePrice || 0), 0) / 100;
        for (const cell of primary.querySelectorAll('.cart-item__totals')) {
          let combined = cell.querySelector('.lmd-cart-combined-price');
          if (!combined) { combined = document.createElement('div'); combined.className = 'lmd-cart-combined-price'; cell.append(combined); }
          const formatted = numberFormat.format(total);
          if (combined.textContent !== formatted) combined.textContent = formatted;
        }
      }
    }
  }
  function arrange() {
    pending = false;
    groupLines();
    const drawer = document.querySelector('#CartDrawer');
    const slot = drawer?.querySelector('.lmd-cart-upsells');
    const footer = drawer?.querySelector('.drawer__footer');
    if (!slot || !footer) return;
    for (const container of footer.querySelectorAll('[data-essential-upsell-element="container"]')) {
      let host = container;
      while (host.parentElement && host.parentElement !== footer) host = host.parentElement;
      if (host.parentElement === footer) slot.append(host);
    }
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(arrange);
  }
  const observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList: true, subtree: true });
  const reloadKey = 'lmd-cart-open-reload';
  addEventListener('pagehide', () => {
    try {
      const drawer = document.querySelector('cart-drawer');
      if (drawer?.classList.contains('active')) {
        sessionStorage.setItem(reloadKey, String(drawer.querySelector('cart-drawer-items')?.scrollTop || 0));
      } else sessionStorage.removeItem(reloadKey);
    } catch (_) {}
  });
  try {
    const previousScroll = sessionStorage.getItem(reloadKey);
    sessionStorage.removeItem(reloadKey);
    if (previousScroll !== null && performance.getEntriesByType('navigation')[0]?.type === 'reload') {
      customElements.whenDefined('cart-drawer').then(() => {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer || drawer.classList.contains('is-empty')) return;
        drawer.open();
        requestAnimationFrame(() => {
          const items = drawer.querySelector('cart-drawer-items');
          if (items) items.scrollTop = Number(previousScroll) || 0;
        });
      });
    }
  } catch (_) {}
  schedule();
})();
